import { render, staticRenderFns } from "./searchBarSmall.vue?vue&type=template&id=2a6b3cc6&scoped=true"
import script from "./searchBarSmall.vue?vue&type=script&lang=js"
export * from "./searchBarSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6b3cc6",
  null
  
)

export default component.exports